import {
  Modal,
  ModalOverlay,
  ModalContent,
  VStack,
  Divider,
} from "@chakra-ui/react";
import { Link } from "@ui/components/link";
import { Button, Button_T } from "@ui/components/button";
import { LinkWithLabel_T } from "../nav-content";
import { ReactNode } from "react";

interface PremiumMobileMenuProps {
  isOpen: boolean;
  onClose(): void;
  children: ReactNode;
  links: LinkWithLabel_T[];
  buttons: Array<Button_T & { isInternal?: boolean }>;
}

/* Menu links expand using a modal */
export const PremiumMobileMenu = ({
  isOpen,
  onClose,
  children,
  links,
  buttons,
}: PremiumMobileMenuProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      // Slide in from the right
      motionPreset="slideInRight"
      // Autofocus looks odd
      autoFocus={false}
    >
      <ModalOverlay
        // Set the z index to 0 so that the overlay doesn't cover the main navbar
        zIndex={0}
      />
      <ModalContent
        // Set absolute position to top right (below main navbar)
        pos="absolute"
        right="0"
      >
        <VStack
          w="fit-content"
          h="fit-content"
          bg="white"
          p="4"
          // Set absolute position to top right (below main navbar)
          pos="absolute"
          right="0"
          top="-1"
          // Set bottom left corner with radius
          borderRadius="none"
          borderBottomLeftRadius="lg"
          fontWeight="semibold"
          fontSize="16px"
          divider={<Divider />}
        >
          {/* Add extra children, i.e premium menus here */}
          {children}
          {/* Add links and buttons as children*/}
          {links?.map(({ label, isInternal, ...rest }, idx) => (
            <Link
              key={`link-${idx}`}
              onClick={onClose}
              display="flex"
              alignItems="center"
              height="10"
              color="blueGray.800"
              _hover={{
                color: "blueGray.500",
              }}
              {...rest}
            >
              {label}
            </Link>
          ))}
          {buttons?.map(({ isInternal, ...but }, idx) => {
            return <Button key={`button-${idx}`} {...but} width="160px" />;
          })}
        </VStack>
      </ModalContent>
    </Modal>
  );
};
